import { render } from "./BasicColumnChartDaily.vue?vue&type=template&id=6bd9557c"
import script from "./BasicColumnChartDaily.vue?vue&type=script&lang=js"
export * from "./BasicColumnChartDaily.vue?vue&type=script&lang=js"
script.render = render

export default script